import {put, take} from "redux-saga/effects";
import {revealTile, setLevelProgress} from "../../game/actions";
import {ActionType, getType} from "typesafe-actions";
import {TileType} from "../../game/types";
import {showTutorial} from "../../tutorial/actions";

export default function* () {
    yield put(showTutorial.request({
        title: "gameplay.levelmap.revealtilebonustutor",
        closeOnTouch: true,
    }));

    const {payload: tile} : ActionType<typeof revealTile> = yield take(getType(revealTile));

    if (tile.isRevealed)
        return false;

    yield put(setLevelProgress({
        isExitFound: tile.tileType === TileType.Exit,
        levelProgress: {
            [tile.id]: {
                id: tile.id,
                isRevealed: true
            }
        }
    }));

    return true;
}